let Store;
const _ = require('lodash');
const { EventEmitter } = require('events');
const logger = require('@gral/log');
const k = require('@gral/constants');
const dispatcher = require('@flux/dispatcher/dispatcher');

module.exports = Store = (function () {
  Store = class Store {
    static initClass() {
      this.prototype.storeDomain = 'unknownStoreDomain';

      _.extend(Store.prototype, EventEmitter.prototype);
    }

    constructor() {
      this.log = logger(`STORE-${this.storeDomain.toUpperCase()}`);
      this.log.info('Creating store...');
      this.dispatchToken = dispatcher.register(this._processAction.bind(this));
    }

    _processAction(action) {
      const supportsAction = Array.from(this.supportedActions).includes(action.type);
      if (supportsAction) {
        this._logAction(action);

        const camelCaseActionType = `_${_.camelCase(action.type)}`;
        if (typeof this[camelCaseActionType] === 'function') {
          this[camelCaseActionType](action);
        } else {
          throw new Error(`The function ${camelCaseActionType} no exists.`);
        }
      }
    }

    _logAction(action) {
      this.log.info(`Rx #${action.seq} ${action.type} (src: ${action.source})`);
    }

    waitFor(stores) {
      if (stores == null) {
        stores = [];
      }
      stores = _.flatten([stores]);
      return dispatcher.waitFor(_.map(stores, 'dispatchToken'));
    }

    //--------------------------------------------------------
    addChangeListener(cb) {
      this.addListener(k.events.CHANGE, cb);
    }
    removeChangeListener(cb) {
      this.removeListener(k.events.CHANGE, cb);
    }
    emitChange(action) {
      const actionType = action ? action.type : '';
      this.emit(k.events.CHANGE, this.storeDomain, actionType);
    }
  };
  Store.initClass();
  return Store;
})();
